import { Explanation } from '@cancercentrum/rcc-react';
import type { ReactElement } from 'react';

const VardrelationExplanation = (): ReactElement => (
    <Explanation>För att få åtkomst till information gäller bestämmelsen att personal får ta del av information om de deltar i vården av patienten eller av annat skäl behöver uppgifterna i sitt arbete inom hälso- och sjukvård.</Explanation>
);

export default VardrelationExplanation;
